<nb-card class="cardSolucionadas">
  <app-spinner *ngIf="showSpinnerFotos"></app-spinner>
  <div *ngIf="!showSpinnerFotos">
    <nb-card-header class="HeaderSolucionadas">
      <h3 class="TitulosSolucionadas">{{data.vin}}</h3>
    </nb-card-header>
    <nb-card-header>
      <div class="ReceptorSolucionada">
        <h3 class="TituloReceptor">RECEPTOR</h3>
      </div>
    </nb-card-header>
    <nb-card-body class="row" style="margin-top: -30px">
      <div class="col-6 slide">
         <!-- [gestures]="false" -->
        <!-- <gallery class="appGallery" name="receptor" id="receptor" thumbWidth=100 thumbPosition="left"
          [items]="itemsReceptor" [itemTemplate]="itemTemplateReceptor" ></gallery> -->

            <!-- GALERIA MAIN -->

              <div class="gallery-container">
                <!-- Miniaturas a la izquierda -->
                <div class="thumbnails vertical">
                  <img
                    *ngFor="let img of imageDataReceptor; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen principal con contador y flechas -->
                      <div class="main-image-container">
                        <div class="counter">{{selectedIndex + 1}} / {{imageDataReceptor.length}}</div>

                        <div class="main-image-with-nav" style="position: relative; display: inline-block;">
                          <button 
                            class="nav-btn prev"
                            (click)="prevImage()"
                            [disabled]="selectedIndex === 0"
                            title="Imagen anterior"
                            type="button"
                          >
                            &#10094;
                          </button>

                          <img
                            [src]="selectedImageData"
                            alt="Imagen principal"
                            (click)="openLightbox()"
                            style="display: block;"
                          >

                          <button 
                            class="nav-btn next"
                            (click)="nextImage()"
                            [disabled]="selectedIndex === imageDataReceptor.length - 1"
                            title="Imagen siguiente"
                            type="button"
                          >
                            &#10095;
                          </button>
                        </div>
                      </div>


              </div>


            <!-- Lightbox -->
            <div class="lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
              <div
                class="lightbox-content with-thumbs"
                (click)="$event.stopPropagation()"
                (wheel)="onWheel($event)"
              >
                <span class="close-btn" (click)="closeLightbox()">&times;</span>

                <!-- Miniaturas izquierda en lightbox -->
                <div class="thumbnails vertical lightbox-thumbs">
                  <img
                    *ngFor="let img of imageDataReceptor; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen zoomable con flechas -->
                <div class="zoom-container-with-nav">
                
                  <div class="zoom-container">
                    <div class="counter">{{selectedIndex + 1}} / {{imageDataReceptor.length}}</div>
                    <img
                      [src]="selectedImageData"
                      [style.transform]="'translate(' + currentX + 'px, ' + currentY + 'px) scale(' + zoom + ')'"
                      alt="Imagen ampliada"
                      class="zoom-image"
                      (mousedown)="onMouseDown($event)"
                      (mousemove)="onMouseMove($event)"
                      (mouseup)="onMouseUp()"
                      (mouseleave)="onMouseLeave()"
                      draggable="false"
                    />
                        <button class="nav-btn prev" (click)="prevImage()">&lt;</button>
                      <button class="nav-btn next" (click)="nextImage()">&gt;</button>
                  </div>
              
                </div>
              </div>
            </div>


          <!-- END GALERIA MAIN -->


      </div>
      <div class="col-6">
        <div class="datosCedente">
          <h3>Avería Receptor</h3>
          <p>{{data.averiaReceptor}}</p>
        </div>
        <div class="datosCedente">
          <h3>Área Receptor</h3>
          <p>{{data.areaReceptor}}</p>
        </div>
        <div class="datosCedente">
          <h3>Severidad Receptor</h3>
          <p>{{data.severidadReceptor}}</p>
        </div>
        <div *ngIf="!data.correctaReceptor" class="float-right" style="margin-top: 5px;">
          <button nbButton size="medium" class="btn-Cancelar">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
        <div *ngIf="data.correctaReceptor" class="float-right" style="margin-top: 5px;">
          <button nbButton size="medium" class="btn-Aceptar">
            <nb-icon icon="checkmark-outline"></nb-icon>
          </button>
        </div>
        <div class="float-left">
          <button nbButton size="small" class="buttontz float-left"
            (click)="lightboxReceptor.open(0, 'lightboxReceptor', {panelClass: 'fullscreen'})">
            <nb-icon nbPrefix icon="expand-outline"></nb-icon>
          </button>
        </div>
      </div>
    </nb-card-body>
  </div>
</nb-card>

<nb-card class="cardSolucionadas" style="margin-top: -30px">
  <app-spinner *ngIf="showSpinnerFotos"></app-spinner>
  <div *ngIf="!showSpinnerFotos">
    <nb-card-header>
      <div class="CedenteSolucionada">
        <h3 class="TituloCedente">CEDENTE</h3>
      </div>
    </nb-card-header>
    <nb-card-body class="row" style="margin-top: -30px">
      <div class="col-6 slide">
         <!-- [gestures]="false" -->
        <!-- <gallery class="appGallery" name="cedente" id="cedente"  thumbWidth=100 thumbPosition="left"
          [items]="itemsCedente" [itemTemplate]="itemTemplateCedente"></gallery> -->

          <!-- ********************************************************************** -->
            <!-- CEDENTE CEDENTE CEDENTE -->
             <!-- GALERIA MAIN CEDENTE-->

              <div class="gallery-container">
                <!-- Miniaturas a la izquierda -->
                <div class="thumbnails vertical">
                  <img
                    *ngFor="let img of imageDataCedente; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen principal con contador y flechas -->
                      <div class="main-image-container">
                        <div class="counter">{{selectedIndex + 1}} / {{imageDataCedente.length}}</div>

                        <div class="main-image-with-nav" style="position: relative; display: inline-block;">
                          <button 
                            class="nav-btn prev"
                            (click)="prevImage()"
                            [disabled]="selectedIndex === 0"
                            title="Imagen anterior"
                            type="button"
                          >
                            &#10094;
                          </button>

                          <img
                            [src]="selectedImageDataCedente"
                            alt="Imagen principal"
                            (click)="openLightbox()"
                            style="display: block;"
                          >

                          <button 
                            class="nav-btn next"
                            (click)="nextImageCedente()"
                            [disabled]="selectedIndex === imageDataCedente.length - 1"
                            title="Imagen siguiente"
                            type="button"
                          >
                            &#10095;
                          </button>
                        </div>
                      </div>


              </div>


            <!-- Lightbox -->
            <div class="lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
              <div
                class="lightbox-content with-thumbs"
                (click)="$event.stopPropagation()"
                (wheel)="onWheel($event)"
              >
                <span class="close-btn" (click)="closeLightbox()">&times;</span>

                <!-- Miniaturas izquierda en lightbox -->
                <div class="thumbnails vertical lightbox-thumbs">
                  <img
                    *ngFor="let img of imageDataCedente; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen zoomable con flechas -->
                <div class="zoom-container-with-nav">
                
                  <div class="zoom-container">
                    <div class="counter">{{selectedIndex + 1}} / {{imageDataCedente.length}}</div>
                    <img
                      [src]="selectedImageDataCedente"
                      [style.transform]="'translate(' + currentX + 'px, ' + currentY + 'px) scale(' + zoom + ')'"
                      alt="Imagen ampliada"
                      class="zoom-image"
                      (mousedown)="onMouseDown($event)"
                      (mousemove)="onMouseMove($event)"
                      (mouseup)="onMouseUp()"
                      (mouseleave)="onMouseLeave()"
                      draggable="false"
                    />
                        <button class="nav-btn prev" (click)="prevImage()">&lt;</button>
                      <button class="nav-btn next" (click)="nextImage()">&gt;</button>
                  </div>
              
                </div>
              </div>
            </div>


          <!-- END GALERIA MAIN -->
      </div>
      <div class="col-6">
        <div class="datosCedente">
          <h3>Avería Cedente</h3>
          <p>{{data.averiaCedente}}</p>
        </div>
        <div class="datosCedente">
          <h3>Área Cedente</h3>
          <p>{{data.areaCedente}}</p>
        </div>
        <div class="datosCedente">
          <h3>Severidad Cedente</h3>
          <p>{{data.severidadCedente}}</p>
        </div>
        <div *ngIf="!data.correctaCedente" class="float-right" style="margin-top: 5px;">
          <button nbButton size="medium" class="btn-Cancelar">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
        <div class="float-left">
            <!-- (click)="lightboxCedente.open(0, 'lightboxCedente', {panelClass: 'fullscreen'})" -->
          <button nbButton size="small" class="buttontz float-left"
           (click)="openLightbox()">
            <nb-icon nbPrefix icon="expand-outline"></nb-icon>
          </button>
          <button nbButton size="small" class="buttontz" (click)="close()">Cancelar</button>
        </div>
        <div *ngIf="data.correctaCedente" class="float-right" style="margin-top: 5px;">
          <button nbButton size="medium" class="btn-Aceptar">
            <nb-icon icon="checkmark-outline"></nb-icon>
          </button>
        </div>
      </div>
    </nb-card-body>
  </div>
</nb-card>


<ng-template #itemTemplateCedente let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="type === 'imageViewer' && index === currIndex">
    <!-- <gallery [src]="[data.src]" [config]="myConfig"></gallery> -->
  </ng-container>
</ng-template>

<ng-template #itemTemplateReceptor let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="type === 'imageViewer' && index === currIndex">
    <!-- <gallery [src]="[data.src]" [config]="myConfig"></gallery> -->
  </ng-container>
</ng-template>